import React from 'react';
import { LogoLinksInput, LogoLink } from './LogoLinksInput';

interface LogoLinksFieldProps {
  label: string;
  required?: boolean;
  value?: LogoLink[];
  onChange: (_value: LogoLink[]) => void;
  error?: string;
}

export const LogoLinksField: React.FC<LogoLinksFieldProps> = ({
  label,
  required = false,
  value = [],
  onChange,
  error,
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <LogoLinksInput value={value} onChange={onChange} />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </>
  );
};
